module.exports = __webpack_public_path__ + "assets/media/s30.8bc89269.mp3";